import { useState, useEffect } from 'react';

import { Grid, Avatar } from '@mui/material'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';

import ReactLoading from 'react-loading';

import { getUser, getUserAgency, selectAgency, requestAgency } from '../API';
import { groupAgenciesByNom } from '../helpers/agencyLabel';

import { useTranslation } from "react-i18next";

import Cookies from "js-cookie";

import optc from '../optc.json';

const Login = () => {

  const [isCookieSet, setCookie] = useState(Cookies.get("cookieConsent"));
  const [showConsent, setShowConsent] = useState(false);

  const [t] = useTranslation('common');

  const avatarStyle = { backgroundColor: '#4d0077' }

  const [currentAgency, setCurrentAgency] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [loading, setLoading] = useState(0);
  const [openGroup, setOpenGroup] = useState(null);
  const [showRequest, setShowRequest] = useState(false);
  const [requestForm, setRequestForm] = useState({ name: '', email: '', agency: '', message: '' });
  const [requestStatus, setRequestStatus] = useState('');

  const agencyRows = groupAgenciesByNom(optc.optc);

  useEffect(() => {
    getUser()
      .then((response) => {
        if (response.user && response.user.login !== 'admin') {
          sessionStorage.setItem('authed', JSON.stringify(true));
          getUserAgency()
            .then((agency) => {
              const selected = Array.isArray(agency) ? agency[0] : agency;
              setCurrentAgency(selected || '');
            })
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!Cookies.get("cookieConsent")) {
      setShowConsent(true)
    }
  }, [])

  const handleSelectAgency = async (agency) => {
    setLoading(1);
    setErrMsg('');

    try {
      const result = await selectAgency(agency);

      if (!result || result.status !== 200) {
        setErrMsg(1);
        setLoading(0);
        return;
      }

      sessionStorage.setItem('authed', JSON.stringify(true));
      sessionStorage.setItem('selectedAgency', agency);
      window.location.href = '/home';
    } catch (error) {
      setErrMsg(1);
      setLoading(0);
    }
  }

  const closeRequest = () => {
    setShowRequest(false);
    setRequestStatus('');
  };

  const handleRequestChange = (event) => {
    const { name, value } = event.target;
    setRequestForm((current) => ({ ...current, [name]: value }));
  };

  const handleRequestSubmit = async (event) => {
    event.preventDefault();
    setRequestStatus('sending');

    try {
      const result = await requestAgency(requestForm);
      if (!result || result.status !== 200) {
        setRequestStatus('error');
        return;
      }
      setRequestStatus('sent');
      setRequestForm({ name: '', email: '', agency: '', message: '' });
    } catch (error) {
      setRequestStatus('error');
    }
  };

  const handleAcceptCookies = () => {
    Cookies.set("cookieConsent", true, { expires: 365 });
    setCookie(true);
    setShowConsent(false);
  };

  return (
    <>

      {loading == 0 ? '' :
        <div className="ponctualitespinner">
          <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
        </div>}

      <div className="login-page">
        <div className="login-split">
          <aside className="login-guide" aria-labelledby="login-guide-title">
            <p className="login-guide__eyebrow">{t("login.guide.eyebrow")}</p>
            <h1 id="login-guide-title" className="login-guide__title">{t("login.guide.title")}</h1>
            <p className="login-guide__lead">{t("login.guide.lead")}</p>
            <ol className="login-guide__steps">
              <li className="login-guide__step">
                <span className="login-guide__index">1</span>
                <div>
                  <h2 className="login-guide__step-title">{t("login.guide.steps.agency.title")}</h2>
                  <p className="login-guide__step-text">{t("login.guide.steps.agency.text")}</p>
                </div>
              </li>
              <li className="login-guide__step">
                <span className="login-guide__index">2</span>
                <div>
                  <h2 className="login-guide__step-title">{t("login.guide.steps.dashboard.title")}</h2>
                  <p className="login-guide__step-text">{t("login.guide.steps.dashboard.text")}</p>
                </div>
              </li>
              <li className="login-guide__step">
                <span className="login-guide__index">3</span>
                <div>
                  <h2 className="login-guide__step-title">{t("login.guide.steps.detail.title")}</h2>
                  <p className="login-guide__step-text">{t("login.guide.steps.detail.text")}</p>
                  <ul className="login-guide__topics">
                    <li>{t("login.guide.topics.otp")}</li>
                    <li>{t("login.guide.topics.service")}</li>
                    <li>{t("login.guide.topics.km")}</li>
                    <li>{t("login.guide.topics.hours")}</li>
                    <li>{t("login.guide.topics.operations")}</li>
                    <li>{t("login.guide.topics.load")}</li>
                  </ul>
                </div>
              </li>
            </ol>
            <div className="login-guide__feeds">
              <p className="login-guide__feeds-title">{t("login.guide.feedsTitle")}</p>
              <div className="login-guide__feed-row">
                <div className="login-guide__feed">
                  <span className="login-guide__feed-label">{t("login.guide.rt")}</span>
                  <span className="login-guide__feed-value">{t("login.guide.rtEvery")}</span>
                  <span className="login-guide__feed-note">{t("login.guide.rtText")}</span>
                </div>
                <div className="login-guide__feed">
                  <span className="login-guide__feed-label">{t("login.guide.static")}</span>
                  <span className="login-guide__feed-value">{t("login.guide.staticEvery")}</span>
                  <span className="login-guide__feed-note">{t("login.guide.staticText")}</span>
                </div>
              </div>
            </div>
          </aside>
        <div className="login-page__container login-page__container--agencies">
          <div className="login-card shadow p-3 bg-body">
            <Grid align='center'>
              <Avatar style={avatarStyle}><MapOutlinedIcon /></Avatar>
              <h2 className="pt-2 pb-2">Bus RT Insights</h2>
              <p className="login-agency-intro">
                {openGroup ? `${openGroup.nom} — ${openGroup.country} · ${openGroup.region}` : t("login.select")}
              </p>
            </Grid>
            {openGroup ? (
              <button
                type="button"
                className="agency-list__back"
                onClick={() => setOpenGroup(null)}
                disabled={loading == 1}
              >
                {t("login.back")}
              </button>
            ) : null}
            {showRequest ? (
              <form className="agency-request" onSubmit={handleRequestSubmit}>
                <h3 className="agency-request__title">{t("login.request.title")}</h3>
                <label className="agency-request__field">
                  <span>{t("login.request.name")}</span>
                  <input name="name" type="text" required maxLength={120} value={requestForm.name} onChange={handleRequestChange} />
                </label>
                <label className="agency-request__field">
                  <span>{t("login.request.email")}</span>
                  <input name="email" type="email" required maxLength={160} value={requestForm.email} onChange={handleRequestChange} />
                </label>
                <label className="agency-request__field">
                  <span>{t("login.request.agency")}</span>
                  <input name="agency" type="text" required maxLength={160} value={requestForm.agency} onChange={handleRequestChange} />
                </label>
                <label className="agency-request__field">
                  <span>{t("login.request.message")}</span>
                  <textarea name="message" rows={3} maxLength={2000} value={requestForm.message} onChange={handleRequestChange} />
                  <small>{t("login.request.messageHint")}</small>
                </label>
                {requestStatus === 'sent' ? <p className="agency-request__note agency-request__note--ok">{t("login.request.sent")}</p> : null}
                {requestStatus === 'error' ? <p className="agency-request__note agency-request__note--err">{t("login.request.error")}</p> : null}
                <div className="agency-request__actions">
                  <button type="button" className="agency-request__cancel" onClick={closeRequest} disabled={requestStatus === 'sending'}>
                    {t("login.request.cancel")}
                  </button>
                  <button type="submit" className="agency-request__send" disabled={requestStatus === 'sending'}>
                    {requestStatus === 'sending' ? t("login.request.sending") : t("login.request.send")}
                  </button>
                </div>
              </form>
            ) : (
            <div className="agency-list">
              {openGroup
                ? openGroup.members.map((agency) => (
                  <button
                    key={agency.operateur}
                    type="button"
                    className={`agency-list__row${currentAgency === agency.operateur ? ' agency-list__row--active' : ''}`}
                    style={{ '--agency-color': agency.color || '#4d0077' }}
                    onClick={() => handleSelectAgency(agency.operateur)}
                    disabled={loading == 1}
                  >
                    <span className="agency-list__copy">
                      <span className="agency-list__name">{agency.operateur}</span>
                      <span className="agency-list__meta">{agency.country} · {agency.region}</span>
                    </span>
                  </button>
                ))
                : agencyRows.map((row) => (
                  row.type === 'group' ? (
                    <button
                      key={row.nom}
                      type="button"
                      className="agency-list__row agency-list__row--group"
                      style={{ '--agency-color': row.color || '#4d0077' }}
                      onClick={() => setOpenGroup(row)}
                      disabled={loading == 1}
                    >
                      <span className="agency-list__copy">
                        <span className="agency-list__name">{row.nom}</span>
                        <span className="agency-list__meta">{row.country} · {row.region}</span>
                      </span>
                      <span className="agency-list__chevron" aria-hidden="true">›</span>
                    </button>
                  ) : (
                    <button
                      key={row.agency.operateur}
                      type="button"
                      className={`agency-list__row${currentAgency === row.agency.operateur ? ' agency-list__row--active' : ''}`}
                      style={{ '--agency-color': row.agency.color || '#4d0077' }}
                      onClick={() => handleSelectAgency(row.agency.operateur)}
                      disabled={loading == 1}
                    >
                      <span className="agency-list__copy">
                        <span className="agency-list__name">{row.agency.nom}</span>
                        <span className="agency-list__meta">{row.agency.country} · {row.agency.region}</span>
                      </span>
                    </button>
                  )
                ))}
            </div>
            )}
            {showRequest ? null : (
              <button type="button" className="agency-request__open" onClick={() => setShowRequest(true)} disabled={loading == 1}>
                {t("login.request.open")}
              </button>
            )}
            {errMsg !== '' ? (
              <div className="alert alert-danger mt-3 mb-0" role="alert">
                {t("login.selectError")}
              </div>
            ) : null}
          </div>
        </div>
        </div>
      </div>

      {showConsent == true ?
        <div className="login-cookie-banner">
          <div className="login-cookie-banner__content">
            <p className="login-cookie-banner__text">{t('login.cookie')}</p>
            <button type="button" className="btn btn-light login-cookie-banner__btn" onClick={handleAcceptCookies}>
              {t('login.accept')}
            </button>
          </div>
        </div> : ''}

    </>
  );


}

export default Login;
